export default [
  {
    internalName: 'FREE',
    name: 'Free',
    price: '$0/mo',
    features: [
      "No credit card needed. No time limit.",
      "All the basic features you need",
      "Handles weightings and absent students",
      "Keep comments for individual students and tasks",
      "Interactive tutorials so that you can hit the ground running",
      "It's free! Does this option really need spruiking?",
    ]
  },
  {
    internalName: 'PRO',
    name: 'Pro',
    price: '$10/mo (paid annually)',
    features: [
      "Adorable little progress sheets for students, printed 4-per-page and ready to chop up",
      "Email students their results, either for one task or many tasks. Include any feedback that you've given, which also stays in your marksbook.",
      "Australian Curriculum assessment and planning tools. Check to see which standards you're covering, and which ones are missing",
      "SACE assessment and planning tools - print off performance standards sheets that are already labelled & highlighted",
      "Students can submit work online, so that you can stop hunting through your inbox to find the one student who hasn't handed up their work.",
      "A random name spinner for your laptop, projector, or interactive whiteboard &mdash; with the kids' names already in there!",
      "Group picker for random, equal groups",
      "Help Tom out with the costs of running this thing, and support a local Australian small business",
      //"Pause payment when you don't need it, such as during the holidays",
      "Need a hand? Flick me an email and get help straight away.",
      "Have your say on the new features that you want to see and use.",
      "Cancel any time, even if you're still on the free trial.",
      "Want another reason to sign up? <a href=\"/contact\" target=\"_blank\">Let me know</a> and I can make it happen."]
    },
  {
    internalName: 'INSTITUTION',
    name: 'School-wide',
    price: 'Custom-made',
    features: [
      "Discounts available for site licences",
      "Tailored to suit the needs of your school",
      "Can integrate into your existing LMS or login system",
      "Includes top-tier high-priority support"
      ]
  },
]
